<div class="page-container">
  <div class="admin-content">
    <h1>Organization Subscriptions</h1>
    <p class="tagline">Grant or change any organization's plan directly, bypassing Stripe. QA/support use only.</p>

    @if (state() === 'loading') {
      <div class="loading-container flex flex-column flex-align-center p-lg">
        <app-spinner />
      </div>
    }

    @if (state() === 'error') {
      <div class="error-container p-lg" data-testid="admin-subscriptions-error">
        <p>Couldn't load organizations. Please try again.</p>
      </div>
    }

    @if (state() === 'loaded') {
      <app-card>
        <table class="admin-table">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Org Status</th>
              <th>Plan</th>
              <th>Subscription Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.id) {
              <tr [attr.data-testid]="'admin-org-row-' + row.id">
                <td>{{ row.name }}</td>
                <td>{{ row.customerStatus }}</td>
                <td>
                  <app-select>
                    <select [(ngModel)]="row.planId" [disabled]="row.saving" [attr.data-testid]="'plan-select-' + row.id">
                      @for (plan of plans(); track plan.id) {
                        <option [value]="plan.id">{{ plan.name }}</option>
                      }
                    </select>
                  </app-select>
                </td>
                <td>
                  <app-select>
                    <select [(ngModel)]="row.status" [disabled]="row.saving" [attr.data-testid]="'status-select-' + row.id">
                      @for (status of statuses; track status) {
                        <option [value]="status">{{ status }}</option>
                      }
                    </select>
                  </app-select>
                </td>
                <td>
                  <app-button variant="filled" [disabled]="!isDirty(row) || row.saving" (click)="save(row)"
                    [attr.data-testid]="'save-org-' + row.id">
                    {{ row.saving ? 'Saving...' : 'Save' }}
                  </app-button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-card>
    }
  </div>
</div>
